/**
 * 门户词云默认配置数据
 */
export const home = [
  {
    color: "rgba(255,255,255,1)",
    fontWeight: 600,
    fontSize: 21
  },
  {
    styleId:2,
    color: "rgba(255,255,255,1)",
    textDirection: "vertical",
    animateSets: {
      animateClass: "marquee",
      animateDelay: 3,
      animateDirection: "向左",
      animateDuration: 6,
      animateTriggerNumType: "多次触发",
      animateType: 1,
      executionAnimateClass: "",
      hasDirection: false
    }
  }
]

/**
 * 大屏词云默认配置数据
 */
export const bs = [
  {
    color: "rgba(255,255,255,1)",
    fontWeight: 600,
    fontSize: 21
  },
  {
    styleId:2,
    color: "rgba(255,255,255,1)",
    textDirection: "vertical",
    animateSets: {
      animateClass: "marquee",
      animateDelay: 3,
      animateDirection: "向左",
      animateDuration: 6,
      animateTriggerNumType: "多次触发",
      animateType: 1,
      executionAnimateClass: "",
      hasDirection: false
    }
  }
]

/**
 * app词云默认配置数据
 */
export const appHome = [
  {
    color: "rgba(255,255,255,1)",
    fontWeight: 600,
    fontSize: 21
  },
  {
    styleId:2,
    color: "rgba(255,255,255,1)",
    textDirection: "vertical",
    animateSets: {
      animateClass: "marquee",
      animateDelay: 3,
      animateDirection: "向左",
      animateDuration: 6,
      animateTriggerNumType: "多次触发",
      animateType: 1,
      executionAnimateClass: "",
      hasDirection: false
    }
  }
]